import { Amplify } from '@aws-amplify/core';
import { MyStorage, decryptCredentials as decryptEnv } from './storageHelper';
import { decryptCredentials } from './cifrate';

export let codigoCoberturasDecode = JSON.parse(decryptCredentials(process.env.REACT_APP_COD_COVERAGE));
export let altServer = '';
export let urlLbliv = '';
export let securityDecode = [JSON.parse(decryptCredentials(process.env.REACT_APP_SECURITYCODE))];
export let configVisaDecode = JSON.parse(decryptCredentials(process.env.REACT_APP_VISA_DECODE));
export const adviserConfig = JSON.parse(decryptCredentials(process.env.REACT_APP_ADVISER_CONFIG));
export const tripPlansConfig = JSON.parse(decryptCredentials(process.env.REACT_APP_TRIP_PLANS_CONFIG));
export const tripPlansViajes = JSON.parse(decryptCredentials(process.env.REACT_APP_TRIP_DESTINATION));
export const SUMA_ASEGURADA_EXCLUIDA = JSON.parse(decryptCredentials(process.env.REACT_APP_SUMAA_EXCLUIDA));
export const TIEMPO_AHORRO_EXCLUIDO = JSON.parse(decryptCredentials(process.env.REACT_APP_TIEMPOA_EXCLUIDO));
export const PORCENTAJE_DEV_EXCLUIDO = JSON.parse(decryptCredentials(process.env.REACT_APP_PORCENTAJED_EXCLUIDO));
export const JOBS_LIMIT_SIZE = decryptCredentials(process.env.REACT_APP_JOBS_LIMIT_SIZE);
export const APP_KEY_ENCRYPT = decryptCredentials(process.env.REACT_APP_ENCRYPT_KEY_APP);
export const API_KEY_CONTENTSTACK = decryptCredentials(process.env.REACT_APP_API_KEY_CONTENTSTACK);
const region = decryptCredentials(process.env.REACT_APP_AWS_REGION);
const regionCT = decryptCredentials(process.env.REACT_APP_AWS_REGION_CT);
export const PRODUCT_CODE_VE = decryptCredentials(process.env.REACT_APP_PRODUCT_CODE_VE);
export const API_IS_MODE_PROD = region === 'us-east-1';
export const API_KEY_CS_CONTENT_TYPE = decryptCredentials(process.env.REACT_APP_API_KEY_CS_CONTENT_TYPE);

const amplifyConfig = (config, typeConfig = 'VIDA') => {
  altServer = decryptEnv(
    decryptCredentials(process.env.REACT_APP_ALT_URL_SERVER)
  );
  urlLbliv = decryptEnv(
    decryptCredentials(process.env.REACT_APP_ALT_URL_SERVER)
  );

  const endpointDecode = [
    {
      'name': 'TERCEROS',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_TERCEROS),
      region,
    },
    {
      'name': 'APIS_VCT',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_APIS_VCT),
      region,
    },
    {
      'name': 'APIS_SESSION',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_SESSION_CHECKOUT),
      region,
    },
    {
      'name': 'UTILITARIOS',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_UTILITARIOS),
      region,
    },
    {
      'name': 'DIGITAL_ID',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_DIGITAL_ID),
      region,
    },
    {
      'name': 'BIOMETRICO',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_BIOMETRICO),
      region,
    },
    {
      'name': 'SOAT',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_API_CANAL_SOAT),
      region,
    },
    {
      'name': 'CANAL_CROSS',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_API_CROSS_CANAL),
      region
    },
    {
      'name': 'CANAL_VIDA_CT',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_VIDA_CT),
      region: regionCT
    },
    {
      'name': 'API-CANAL-CONTENTSTACK',
      'endpoint': decryptCredentials(process.env.REACT_APP_API_CANAL_CONTENTSTACK),
      region: regionCT
    },
    {
      'name': 'API_CANAL_CS_CONTENT_TYPE',
      'endpoint': decryptCredentials(process.env.REACT_APP_API_CANAL_CS_CONTENT_TYPE),
      region: regionCT
    },
  ];

  Amplify.configure({
    Auth: {
      region,
      identityPoolId: decryptCredentials(process.env.REACT_APP_AWS_IDENTITY_POOL_ID),
      storage: MyStorage,
    },
    API: {
      endpoints: endpointDecode,
    },
    Storage: {
      region,
    },
  });

  return endpointDecode;
};

export default {
  amplifyConfig
};
